module.exports = __webpack_public_path__ + "img/icon-placeholder-1.df5d2067.svg";